export const mlaCheckEmailStatusMock: Record<string, { data: string; success: boolean }> = {
  active: { data: 'Active', success: true },
  inactive: { data: 'Inactive', success: true },
  'not-exist': { data: 'NotExist', success: true },
};

export const mlaSendPasswordResetMock: Record<string, { success: boolean }> = {
  success: { success: true },
};

export const mlaUpdatePasswordWithTokenMock: Record<
  string,
  { success: boolean; data?: { email: string }; message?: string }
> = {
  success: { data: { email: 'user@example.com' }, success: true },
  'token-used': { success: false, message: 'password reset token has already been used' },
  'token-expired': { success: false, message: 'password reset token has expired' },
};
